<template>
  <div>
    <vs-prompt
      :title="titleText"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      :accept-text="isNew ? 'Add' : 'Update'"
      :is-valid="validForm && $AuthService.hasPermission('vp.crm.automations.edit')"
      class="addActionPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Action</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select v-model="type">
                <vs-select-item
                  :key="index"
                  :value="item.type"
                  :text="item.description"
                  v-for="(item, index) in actionTypes"
                />
              </vs-select>
            </div>
          </div>

          <component
            v-bind:is="'New' + type"
            :action="action"
            :automationId="automationId"
            ref="customFields"
          />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Run after</span>
            </div>
            <div class="vx-col">
              <vs-input
                :placeholder="delayDescription"
                v-on:input="delayChange"
                v-model="delayUserDescription"
              />
              <p class="p-1">This action runs after {{ delayDescription }}</p>
              <!--<vs-input-number v-model="delay" />-->
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Conditions</span>
            </div>
          </div>

          <conditions
            :conditions="conditions"
            :automationId="automationId"
            ref="conditions"
          />

          <div class="buttons-footer-left">
            <vs-button
              v-if="!isNew && $AuthService.hasPermission('vp.crm.automations.edit')"
              color="danger"
              @click.native="confirmDelete"
              type="border"
              class=""
              >Delete</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NewSendMailAction from "./NewSendMailAction.vue";
import NewSendSmsAction from "./NewSendSmsAction.vue";
import NewAddPointsAction from "./NewAddPointsAction.vue";
import NewCreateNightpayVoucherAction from "./NewCreateNightpayVoucherAction.vue";
import NewAddLabelAction from "./NewAddLabelAction.vue";

import parse from "parse-duration";
import humanizeDuration from "humanize-duration";
import Conditions from "./Conditions/Conditions.vue";

export default {
  components: {
    NewSendMailAction,
    NewSendSmsAction,
    NewAddLabelAction,
    NewAddPointsAction,
    NewCreateNightpayVoucherAction,
    Conditions,
  },
  data() {
    return {
      parse,
      humanizeDuration,
      automationId: "",
      isNew: true,
      delayUserDescription: "",
      type: "SendMailAction",
      delay: 0,
      prompt: false,
      conditions: [],
      action: null,
    };
  },
  computed: {
    validForm() {
      return true;
    },
    titleText() {
      return this.isNew ? "Add action" : "Update action";
    },
    ...mapGetters({
      actionTypes: "automations/actionTypes",
    }),
    delayDescription() {
      return this.humanizeDuration(this.delay);
    },
  },
  methods: {
    delayChange() {
      this.delay = this.parse(this.delayUserDescription);
    },
    confirmDelete() {
      this.addNewTodoPrompt = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Delete?",
        accept: this.delete,
      });
    },
    show(automationId, action) {
      this.automationId = automationId;
      this.action = action;

      this.id = this.uuidv4();
      this.type = "SendMailAction";
      this.delayUserDescription = "";
      this.delay = 0;
      this.isNew = true;
      this.conditions = [];

      if (action) {
        this.isNew = false;
        this.id = action.id;
        this.conditions = action.conditions;
        this.type = action._type;
        this.delay = action.delay;
      }

      this.prompt = true;
    },
    async delete() {
      const dto = {
        automationId: this.automationId,
        actionId: this.id,
      };
      console.log("Deleting", dto);
      await this.$store.dispatch("automations/deleteAction", dto);
      this.prompt = false;
    },
    async accept() {
      const action = {
        id: this.id,
        delay: parseInt(this.delay),
        _type: this.type,
        conditions: this.$refs.conditions.render(),
        ...this.$refs.customFields.render(),
      };

      const dto = {
        automationId: this.automationId,
        action: action,
      };

      this.$vs.loading();
      if (this.isNew) {
        console.log("creating", dto);
        await this.$store.dispatch("automations/createAction", dto);
      } else {
        console.log("Updating", dto);
        await this.$store.dispatch("automations/updateAction", dto);
      }

      this.$vs.loading.close();

      this.prompt = false;
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    close() {},
  },
};
</script>

<style lang="scss"  >
.addActionPopup.con-vs-dialog .vs-dialog {
  max-width: 600px !important;
  position: relative;
}
</style>


<style lang="scss" scoped>
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.buttons-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}
</style>
